import { apiFetch } from "./api";

export interface JobFileDto {
  jobFileId: number;
  jobId: number;
  originalFileName: string;
  category: string | null;
  description: string | null;
  currentVersionId: number | null;
  currentVersionSeq: number | null;
  currentSizeBytes: number | null;
  currentContentType: string | null;
  currentUploadedAtUtc: string | null;
  currentUploadedByUserName: string | null;
  rowVersionBase64: string;
}

export interface JobFileVersionDto {
  jobFileVersionId: number;
  jobFileId: number;
  versionSeq: number;
  originalFileName: string;
  contentType: string;
  sizeBytes: number;
  sha256Hex: string;
  uploadedAtUtc: string;
  uploadedByUserName: string;
}

export interface JobInternalFileLinkDto {
  jobInternalFileLinkId: number;
  jobId: number;
  linkDisplayText: string;
  comment: string | null;
  rowVersionBase64: string;
}

export const jobFileKeys = {
  list: (jobId: number) => ["jobs", jobId, "files"] as const,
  versions: (jobId: number, fileId: number) => ["jobs", jobId, "files", fileId, "versions"] as const,
  internalLinks: (jobId: number) => ["jobs", jobId, "internal-links"] as const,
};

export const jobFiles = {
  list: (jobId: number) => apiFetch<JobFileDto[]>(`/api/jobs/${jobId}/files`),
  upload: (jobId: number, file: File) => {
    const form = new FormData();
    form.append("file", file);
    return apiFetch<{ jobFileId: number; jobFileVersionId: number; versionSeq: number }>(
      `/api/jobs/${jobId}/files`, { method: "POST", body: form });
  },
  uploadVersion: (jobId: number, fileId: number, file: File) => {
    const form = new FormData();
    form.append("file", file);
    return apiFetch<{ jobFileId: number; jobFileVersionId: number; versionSeq: number }>(
      `/api/jobs/${jobId}/files/${fileId}/versions`, { method: "POST", body: form });
  },
  versions: (jobId: number, fileId: number) =>
    apiFetch<JobFileVersionDto[]>(`/api/jobs/${jobId}/files/${fileId}/versions`),
  downloadUrl: (jobId: number, fileId: number, versionId: number) =>
    `/api/jobs/${jobId}/files/${fileId}/versions/${versionId}/download`,
  remove: (jobId: number, fileId: number) =>
    apiFetch<void>(`/api/jobs/${jobId}/files/${fileId}`, { method: "DELETE" }),

  internalLinks: {
    list: (jobId: number) =>
      apiFetch<JobInternalFileLinkDto[]>(`/api/jobs/${jobId}/internal-links`),
    create: (jobId: number, body: { linkDisplayText: string; comment?: string }) =>
      apiFetch<{ jobInternalFileLinkId: number }>(`/api/jobs/${jobId}/internal-links`, { method: "POST", body: JSON.stringify(body) }),
    update: (jobId: number, id: number, body: { linkDisplayText: string; comment?: string; rowVersionBase64: string }) =>
      apiFetch<void>(`/api/jobs/${jobId}/internal-links/${id}`, { method: "PUT", body: JSON.stringify(body) }),
    remove: (jobId: number, id: number, rowVersionBase64: string) =>
      apiFetch<void>(`/api/jobs/${jobId}/internal-links/${id}?rowVersionBase64=${encodeURIComponent(rowVersionBase64)}`, { method: "DELETE" }),
  },
};
